import { render, staticRenderFns } from "./ButtonComponent.vue?vue&type=template&id=28c1b974&lang=html&"
import script from "./ButtonComponent.vue?vue&type=script&lang=js&"
export * from "./ButtonComponent.vue?vue&type=script&lang=js&"
import style0 from "./ButtonComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports